import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./globals.css";
import { checkAppVersion, registerChunkErrorRecovery } from "./app-version";
import { isTabletDevice } from "@/utils/browserEnv";

// Log preload errors but don't auto-reload.
// Crash recovery is handled by the inline script in index.html.
window.addEventListener("vite:preloadError", (event) => {
  console.warn("[Vite] Preload error detected:", event);
});

// Phones must never see any install prompt (incl. Chrome's native mini-infobar).
// Tablets keep the custom InstallPrompt flow untouched.
if (!isTabletDevice()) {
  window.addEventListener("beforeinstallprompt", (e) => e.preventDefault());
}

checkAppVersion();
registerChunkErrorRecovery();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
